"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = __importDefault(require("./styles"));
var Field = function (_a) {
    var children = _a.children, isHidden = _a.isHidden, className = _a.className, style = _a.style, label = _a.label, isDisabled = _a.isDisabled;
    if (isHidden)
        return null;
    var classNames = (className || '') + " " + (isDisabled ? 'disabled' : '');
    return (react_1.default.createElement(styles_1.default, { className: classNames, style: style },
        react_1.default.createElement("label", { className: "label" }, label),
        children));
};
exports.default = Field;
//# sourceMappingURL=index.js.map